export const PAC = 'PAC'
export const STAC = 'STAC'
export const MAX_FAMILY_PORT_IN_NUMBERS = 10
export const UK_PHONE_NUMBER_PREFIX = '+44'

export const PORT_IN_BUFFER_DAYS = 2
export const PORT_IN_STAC_BUFFER_DAYS = 7

export enum CodeServerErrors {
  LOCKED = 'code_expiry_date_locked',
  EXPIRED = 'code_expiry_date_expired',
  INCORRECT = 'no_code_expiry_date',
  CANNOT_VERIFY = 'code_cannot_verify',
  EXPIRE_SOON = 'code_expired_soon',
  MSISDN_USED = 'msisdn_used',
  NOT_VALID = 'not_valid',
  UNEXPECTED_STATUS = 'unexpected_status',
  MSISDN_USED_BY_USER = 'msisdn_used_by_user',
}
